import icons from '@assets/icons'
import images from '@assets/images'
import React from 'react'

const IconRender = ({ type = 'icon', icon, ...props }) => (
  <img src={type === 'images' ? images[icon] : icons[icon]} alt={icon} {...props} />
)

export default IconRender
